export default __webpack_public_path__ + "static/signin-illustration-8c6fea0fcf2f373fd1782184812f5f01.jpg";